<template>
   <div class="container-fluid cntnr-table p-0 m-0" :style="{'background-color': bgColor}">
      <hr class="m-0 hr-sty"/>
      <nav class="navbar navbar-dark bg-dark p-0">
         <div class="container-fluid">
            <span class="navbar-brand mb-0 h1"><b>{{appModuleComponent.nameInModule}}</b></span>
            <button v-if="filterOnOff"
               type="button" 
               class="btn btn-sm btn-info" 
               @click="filterData()"
               >
               <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-funnel-fill" viewBox="0 0 16 16">
                  <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2z"/>
               </svg>
            </button>
            <ul class="d-flex mb-0">
               <button 
                  type="button" 
                  class="btn btn-dark" 
                  @click="upWizardV310 = true"
                  >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-receipt" viewBox="0 0 16 16">
                     <path d="M1.92.506a.5.5 0 0 1 .434.14L3 1.293l.646-.647a.5.5 0 0 1 .708 0L5 1.293l.646-.647a.5.5 0 0 1 .708 0L7 1.293l.646-.647a.5.5 0 0 1 .708 0L9 1.293l.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .801.13l.5 1A.5.5 0 0 1 15 2v12a.5.5 0 0 1-.053.224l-.5 1a.5.5 0 0 1-.8.13L13 14.707l-.646.647a.5.5 0 0 1-.708 0L11 14.707l-.646.647a.5.5 0 0 1-.708 0L9 14.707l-.646.647a.5.5 0 0 1-.708 0L7 14.707l-.646.647a.5.5 0 0 1-.708 0L5 14.707l-.646.647a.5.5 0 0 1-.708 0L3 14.707l-.646.647a.5.5 0 0 1-.801-.13l-.5-1A.5.5 0 0 1 1 14V2a.5.5 0 0 1 .053-.224l.5-1a.5.5 0 0 1 .367-.27zm.217 1.338L2 2.118v11.764l.137.274.51-.51a.5.5 0 0 1 .707 0l.646.647.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.509.509.137-.274V2.118l-.137-.274-.51.51a.5.5 0 0 1-.707 0L12 1.707l-.646.647a.5.5 0 0 1-.708 0L10 1.707l-.646.647a.5.5 0 0 1-.708 0L8 1.707l-.646.647a.5.5 0 0 1-.708 0L6 1.707l-.646.647a.5.5 0 0 1-.708 0L4 1.707l-.646.647a.5.5 0 0 1-.708 0l-.509-.51z"/>
                     <path d="M3 4.5a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5zm8-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5z"/>
                  </svg>
                  + Voucher
               </button>
               <button 
                  type="button" 
                  class="btn btn-dark" 
                  @click="filterV310 = true"
                  >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-funnel-fill" viewBox="0 0 16 16">
                     <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2z"/>
                  </svg>
                  Filtrar
               </button>
               <!--
               <button 
                  type="button" 
                  class="btn btn-dark" 
                  @click="addVoucher = true"
                  >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-receipt" viewBox="0 0 16 16">
                     <path d="M1.92.506a.5.5 0 0 1 .434.14L3 1.293l.646-.647a.5.5 0 0 1 .708 0L5 1.293l.646-.647a.5.5 0 0 1 .708 0L7 1.293l.646-.647a.5.5 0 0 1 .708 0L9 1.293l.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .801.13l.5 1A.5.5 0 0 1 15 2v12a.5.5 0 0 1-.053.224l-.5 1a.5.5 0 0 1-.8.13L13 14.707l-.646.647a.5.5 0 0 1-.708 0L11 14.707l-.646.647a.5.5 0 0 1-.708 0L9 14.707l-.646.647a.5.5 0 0 1-.708 0L7 14.707l-.646.647a.5.5 0 0 1-.708 0L5 14.707l-.646.647a.5.5 0 0 1-.708 0L3 14.707l-.646.647a.5.5 0 0 1-.801-.13l-.5-1A.5.5 0 0 1 1 14V2a.5.5 0 0 1 .053-.224l.5-1a.5.5 0 0 1 .367-.27zm.217 1.338L2 2.118v11.764l.137.274.51-.51a.5.5 0 0 1 .707 0l.646.647.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.509.509.137-.274V2.118l-.137-.274-.51.51a.5.5 0 0 1-.707 0L12 1.707l-.646.647a.5.5 0 0 1-.708 0L10 1.707l-.646.647a.5.5 0 0 1-.708 0L8 1.707l-.646.647a.5.5 0 0 1-.708 0L6 1.707l-.646.647a.5.5 0 0 1-.708 0L4 1.707l-.646.647a.5.5 0 0 1-.708 0l-.509-.51z"/>
                     <path d="M3 4.5a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5zm8-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5z"/>
                  </svg>
                  + Voucher
               </button>
               -->
               <button 
                  type="button" 
                  class="btn btn-dark" 
                  data-bs-toggle="modal" 
                  data-bs-target="#updateAffiliates"
                  ref="btn_in_mdUpAffil"
               >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-people-fill" viewBox="0 0 16 16">
                     <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7Zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm-5.784 6A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216ZM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"/>
                  </svg>
                  Afiliados
               </button>
            </ul>
         </div>
      </nav>
      <div class=" div-conteiner ">
         <hr class="m-0 hr-sty"/>
         <div class="div-scroll">
         <!--
                     <td class="ws-nowrap">Apellido y Nombre</td>
         -->
            <table class="table table-sm table-primary table-striped table-borderless">
               <thead class="table-dark text-center">
                  <tr class="bg-thead">
                     <td colspan="3" class="border-end">Autorización</td>
                     <td class="border-end">Solicitud</td>
                     <td colspan="3" class="border-end">Afiliado</td>
                     <td colspan="2" class="border-end">Vigencia</td>
                     <td colspan="2"></td>
                  </tr>
               </thead>
               <tbody id="tbid">
                  <tr v-for="(item, index) in vouchers" :key="index" 
                        class="border-0" 
                        >
                     <td>{{item.id}}</td>
                     <td>{{item.nowDate}}</td>
                     <td class="border-end py2px">
                        <user-circle :circleUser="item.myCircle" />
                     </td>
                     <td class="border-end">{{item.requestDate}}</td>
                     <td>{{item.cuil}}</td>
                     <td class="text-nowrap">{{item.name}}</td>
                     <td class="text-nowrap border-end">{{item.provinceState}}</td>
                     <td>{{item.prescriptionDate}}</td>
                     <td class="border-end">{{item.validDate}}</td>
                     <td class="border-end py-0 px-1 hover-click" @click="showV310( 'D', index )">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16">
                           <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                           <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
                        </svg>
                     </td>
                     <td class="border-end py-0 px-1 hover-click" @click="showV310( 'V', index )">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-filetype-pdf" viewBox="0 0 16 16">
                           <path fill-rule="evenodd" d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM1.6 11.85H0v3.999h.791v-1.342h.803q.43 0 .732-.173.305-.175.463-.474a1.4 1.4 0 0 0 .161-.677q0-.375-.158-.677a1.2 1.2 0 0 0-.46-.477q-.3-.18-.732-.179m.545 1.333a.8.8 0 0 1-.085.38.57.57 0 0 1-.238.241.8.8 0 0 1-.375.082H.788V12.48h.66q.327 0 .512.181.185.183.185.522m1.217-1.333v3.999h1.46q.602 0 .998-.237a1.45 1.45 0 0 0 .595-.689q.196-.45.196-1.084 0-.63-.196-1.075a1.43 1.43 0 0 0-.589-.68q-.396-.234-1.005-.234zm.791.645h.563q.371 0 .609.152a.9.9 0 0 1 .354.454q.118.302.118.753a2.3 2.3 0 0 1-.068.592 1.1 1.1 0 0 1-.196.422.8.8 0 0 1-.334.252 1.3 1.3 0 0 1-.483.082h-.563zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638z"/>
                        </svg>
                     </td>
                  </tr>
               </tbody>
            </table>
            <!--
            <br>
            {{vouchers}}
            <br>
            {{filterOnOff}}
            {{vouchers}}
            <div v-for="(item, index) in vouchers" :key="index" class="p-0 m-0 border">
               {{item}}
            </div>
                     <svg v-if="ascendent" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-arrow-up-square " viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm8.5 9.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707z"/>
                     </svg>
                     <svg v-else xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-arrow-down-square" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm8.5 2.5a.5.5 0 0 0-1 0v5.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293z"/>
                     </svg>
         <select v-model="copyPicked" class="form-select mt-1">
            -->
         </div>
         <div class="div-bottom row justify-content-between m-0">
            <div class="col-auto px-1">
               <div class="input-group input-group-sm mt-1">
                  <label class="input-group-text" for="inputGroupSelect01">Orden</label>
                  <select 
                     v-model="selectedField"  
                     class="form-select" 
                     @change="findVouchers(0)"
                     >
                     <option value="v310.id" selected>Autorización</option>
                     <option value="v310.request_date">Solicitud</option>
                     <option value="v310.affiliate_id">C.U.I.L.</option>
                     <option value="state.name">Provincia</option>
                     <option value="v310.prescription_date">Vigencia</option>
                  </select>
                  <button class="btn btn-sm btn-light ppp px-1 py-0" type="button" @click="orderButton()">
                     <svg v-if="ascendent" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-arrow-up" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5"/>
                     </svg>
                     <svg v-else xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-arrow-down" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1"/>
                     </svg>
                  </button>
               </div>
            </div>

            <div class="col-auto px-1">
               <div class="input-group input-group-sm mt-1">
                  <label class="input-group-text" for="inputGroupSelect01">{{totalVouchers}}</label>
                  <button
                     class="btn btn-sm btn-light ppp px-1 py-0" 
                     type="button" 
                     @click="currentPage( -1, pageNumber > 0)"
                     >
                     <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
                     </svg>
                  </button>
                  <label 
                     class="input-group-text"
                     >
                     {{pageNumber + 1}}/{{totalPages}}
                  </label>
                  <button
                     class="btn btn-sm btn-light ppp px-1 py-0" 
                     type="button" 
                     @click="currentPage( 1, pageNumber + 1 < totalPages)" 
                     >
                     <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                     </svg>
                  </button>
               </div>
            </div>
         </div>
      </div>
   </div>
   <!--
   -->
   <external-modal v-if="false" />
   <up-wizard-v-310 
      v-if="upWizardV310" 
      @cancel="upWizardV310 = findVouchers(0)"
      />

   <filter-v-310
      v-if="filterV310" 
      :filterOnOff="filterOnOff"
      @cancel="filterV310 = false"
      @doFilter="(val) => filterVauchers(val)"
      />

   <data-v-310
      v-if="dataV310" 
      :v310Object="v310Object"
      :v310Rest="v310Rest"
      @cancel="dataV310 = false"
      />

   <view-v-310
      v-if="viewV310" 
      :v310Object="v310Object"
      @cancel="viewV310 = false"
      />

   <vue-final-modal v-model="addInModal" :focus-trap="true" attach="#zyx" >
      <div class="container border text-start">
      <button>1</button>
      <br>
      <button @click="$emit('cancel')">2</button>
      <br>
      <button>3</button>
      </div>
   </vue-final-modal>

   <vue-final-modal v-model="addVoucher" :focus-trap="true">
      <up-voucher-310 
         id="upV310"
         @closeAdd="closeUpVouch()" 
         @upDrugs="updateDrugs()"
         />
   </vue-final-modal>

   <up-drugs-v-310 v-if="upDrugs" @outHere="upDrugs = false" />
  <!--
   <up-drugs-v-310 v-if="upDrugs" @outHere="upDrugs = false" />
   <vue-final-modal v-model="upDrugs" :focus-trap="true">
      <up-drugs-v-310 @outHere="upDrugs = false" />
   </vue-final-modal>

   <up-voucher-310 
      v-if="false" 
      @closeAdd="closeUpVouch()" 
      :class=" addVoucher ? 'bg-conteiner' : ''"
      /> 
                  <up-drugs-v-310 @outHere="showUpDrugs = false" />
      -->
   <md-update-affiliates/>
   <md-search-affiliate/>
</template>


<script>
//import { ref, onMounted, watch, computed, nextTick } from 'vue';
import { ref, onMounted, watch, onUnmounted, nextTick } from 'vue';
import { useStore } from 'vuex'
import moment from 'moment';

import { VueFinalModal } from 'vue-final-modal'

import V310Service from "/src/modules/voucher310/voucher310.service.js"
import useEventsBus from '/src/services/eventBus';

import upVoucher310 from './UpVoucher310.vue';
import upDrugsV310 from  '/src/modules/voucher310/components/UpDrugsV310.vue'
import mdUpdateAffiliates from '../../analytics/components/affiliate/MdUpdateAffiliates.vue';
import mdSearchAffiliate from '../../analytics/components/affiliate/MdSearchAffiliate.vue';
//import VueModal from '../../../utilities/components/VueModal.vue';
import UserCircle from '../../../components/UserCircle.vue';

import externalModal from '/src/modules/voucher310/components/ExternalModal.vue'
import UpWizardV310 from './UpWizardV310.vue';
import FilterV310 from './FilterV310.vue';
import ViewV310 from './ViewV310.vue';
import DataV310 from './DataV310.vue';

export default {
   name: 'Voucher310',
   components: {
      upVoucher310,
      mdUpdateAffiliates,
      mdSearchAffiliate,
      VueFinalModal,
      upDrugsV310,
      externalModal,
      UpWizardV310,
      UserCircle,
      FilterV310,
      ViewV310,
      DataV310
   },
   setup() {
      const store = useStore()

      const appNameInModule = ref('')
      const appModuleComponent = ref({})
      const bgColor = ref("#ECEFF1")
      const uAppIndex = ref(0)

      const addVoucher = ref(false)
      const vouchers = ref([])
      const { bus } = useEventsBus()
      const btn_in_mdUpAffil = ref(null)
      //
      const upWizardV310 = ref(false)
      const addInModal = ref(false)
      const filterV310 = ref(false)
      //
      const upDrugs = ref(false)
      const ascendent = ref(false)
      const totalVouchers = ref (0)
      const selectedField = ref('v310.id')
      const totalPages = ref(1)
      const pageNumber = ref(0)
      const filter = ref({})
      const filterOnOff = ref(false)
      //
      const viewV310 = ref(false)
      const dataV310 = ref(false)
      const v310Object = ref({})
      const v310Rest = ref({})

      const timerFindV310 = ref(null)
      onMounted(() => {
         console.log("onMounted in uAppIndex: "+uAppIndex.value)
         uAppIndex.value = store.state.auth.userAppIndex
         console.log("onMounted out uAppIndex: "+uAppIndex.value)
         //
         if (uAppIndex.value !=  null && uAppIndex.value >= 0) {
            let uAppModule = store.state.auth.userAppModule
            console.log(uAppModule.appModuleComponent[uAppIndex.value])
            appModuleComponent.value = uAppModule.appModuleComponent[uAppIndex.value]
            bgColor.value = JSON.parse(appModuleComponent.value.parameters).bgColor
            findVouchers(0)
            timerFindV310.value = setInterval(() => findVouchers( totalVouchers.value ), 30000)
            /*
            if (uAppModule.appModuleComponent[uAppIndex.value].parameters) {
               //store.dispatch("wspace/updateFilterParam", 0, 0)
               store.dispatch("wspace/updateFilterCardTypeId", 0)
               store.dispatch("wspace/updateFilterUserId", 0)
               store.dispatch("wspace/updateFilterLabelId", 0)
               appNameInModule.value =  uAppModule.appModuleComponent[uAppIndex.value].nameInModule
               document.title = appNameInModule.value
               userAppModuleId.value = uAppModule.appModuleComponent[uAppIndex.value].userAppModuleId
               boardId.value = Number(uAppModule.appModuleComponent[uAppIndex.value].parameters)
               getBoard(boardId.value)
            }
            */
         }
         //
      })
      //
      onUnmounted(() => { clearInterval( timerFindV310.value ) })
      
      watch( () => bus.value.get('v310ToDo'), (val) => {
         console.log(val)
         const [toDo] = val ?? []
         console.log(toDo)
         if ( toDo === 'upVouch' ) {
            console.log(toDo)
            addVoucher.value = true
         }
         if ( toDo === 'findVouchers' ) {
            console.log(toDo)
            findVouchers(0)
            console.log(toDo)
         }
      })
      // C
      function closeUpVouch() {
         addVoucher.value = false
         //btn_in_mdUpAffil.value.click()
      }

      function currentPage( value, ok ) {
         if (ok) {
            pageNumber.value += value
            findVouchers(0)
         }
      }
      // D
      function date(dtValue) {
         return moment(dtValue).format('DD-MM-YYYY');
         //return moment(dtValue).format('YYYY-MM-DD HH:mm:ss');
      }
      // F
      function filterData() {
         //let text = "Los datos \n         del filtro"
         let text = ""
         if ( filter.value.dataShow.filterId ) { 
            text += "ID:  " + filter.value.dataFilter.id + "\n"
         }
         if ( filter.value.dataShow.filterCuil ) { 
            text += "CUIL:  " + filter.value.dataFilter.cuil + "\n"
            text += "      " + filter.value.dataShow.cuilName + "\n"
         }
         if ( filter.value.dataShow.filterDates ) { 
            let dateFrom = filter.value.dataFilter.dateFrom === undefined ? "" : filter.value.dataFilter.dateFrom
            let dateTo = filter.value.dataFilter.dateTo === undefined ? "" : filter.value.dataFilter.dateTo
            text += "Fechas de " + filter.value.dataShow.dateType + ":\n"
            text += "      Desde:  " + dateFrom + "\n"
            text += "      Hasta:  " + dateTo + "\n"
         }
         if ( filter.value.dataShow.filterState ) { 
            text += "Provincia:  " + filter.value.dataShow.stateName + "\n"
         }
         if ( filter.value.dataShow.filterUser ) { 
            text += "Usuario:  " + filter.value.dataShow.userName + "\n"
         }
         alert(text)
      }

      function filterVauchers( value ) {
         //filter.value = value
         filter.value = Object.assign( {}, value )
         if ( JSON.stringify( value ) === '{}' ) {
            filterOnOff.value = false
         } else {
            filterOnOff.value = true
         }
         nextTick(() => {
            pageNumber.value = 0
            findVouchers(0)
         })
      }
      
      function findVouchers(records) {
         let ascDesc = 'desc'
         if ( ascendent.value ) {
            ascDesc = 'asc'
         }
         let findV310 = {
            records: records,
            field: selectedField.value,
            order: ascDesc,
            pageNumber: pageNumber.value,
            itemsByPage: 15
         }
         if ( filter.value.dataFilter !== undefined ) {
            if ( filter.value.dataFilter.id !== undefined ) { 
               findV310.id = Number( filter.value.dataFilter.id )
            }
            if ( filter.value.dataFilter.cuil !== undefined ) { 
               findV310.cuil = Number( filter.value.dataFilter.cuil )
            }
            if ( filter.value.dataFilter.dates !== undefined ) { 
               findV310.dates = filter.value.dataFilter.dates
               if ( filter.value.dataFilter.dateFrom !== undefined ) { 
                  findV310.dateFrom = filter.value.dataFilter.dateFrom
               }
               if ( filter.value.dataFilter.dateTo !== undefined ) { 
                  findV310.dateTo = filter.value.dataFilter.dateTo
               }
            }
            if ( filter.value.dataFilter.stateId !== undefined ) { 
               findV310.stateId = filter.value.dataFilter.stateId
            }
            if ( filter.value.dataFilter.userId !== undefined ) { 
               findV310.userId = filter.value.dataFilter.userId
            }
         }
         console.log('findVouchers(): ' + selectedField.value + ' - ' + ascDesc)
         console.log(findV310)
         V310Service.findVouchers(
            /*
            {
            records: records,
            field: selectedField.value,
            order: ascDesc,
            pageNumber: pageNumber.value,
            itemsByPage: 7
            }
            */
           findV310
         )
         .then(response => {
            console.log(response.data)
            if ( records == 0 || totalVouchers.value != response.data.records ) {
               totalVouchers.value = response.data.records
               totalPages.value = response.data.totalPages
               vouchers.value = response.data.vouchers
            }
         })
         .catch(error => {
            console.log(error);
         })
         return false
      }
      // O
      function orderButton() {
         ascendent.value = !ascendent.value
         findVouchers(0)
      }
      // S
      function showV310( dv, index ) {
         v310Object.value = vouchers.value[ index ]
         viewV310.value = ( dv == 'V' )
         if ( dv == 'D' ) {
            console.log(Number(vouchers.value[ index ].id))
            V310Service.getVoucherRestData( Number(vouchers.value[ index ].id ) )
            .then(response => {
               v310Rest.value = response.data
               console.log(response.data)
               nextTick(() => {
                  dataV310.value = true
               })
            })
            .catch(error => {
               console.log(error);
            })
         }
      }
      // U
      function updateDrugs() {
         upDrugs.value = true
         console.log('updateDrugs from upV310')
         //btn_in_mdUpAffil.value.click()
      }

      return {
         addVoucher, appModuleComponent, appNameInModule, addInModal, ascendent,
         bgColor, btn_in_mdUpAffil,
         closeUpVouch, currentPage,
         dataV310, date,
         filter, filterData, filterOnOff, filterV310, filterVauchers, findVouchers,
         orderButton,
         pageNumber,
         selectedField, showV310,
         totalPages, totalVouchers,
         uAppIndex, upDrugs, updateDrugs, upWizardV310,
         v310Object, v310Rest, viewV310, vouchers
      }
   },
}
</script>

<style scoped>
   .cntnr-table {
      height: calc(100vh - 40px);
      color: white;
   }
   .div-conteiner {
      position: relative;
      height: calc(100vh - 80px);
      /*height: calc(100% - 80px);
      overflow-y: auto;*/
   }
   .bg-conteiner {
      /*background-color: rgba(0, 0, 0, .30);*/
      background-color: rgba(0, 0, 0, .50);
   }
   .tx-cl-white {
      color: white;
   }
.modal__close {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
}
.py2px {
   padding-bottom: 2px;
   padding-top: 2px;
}
.div-scroll {
   height: calc(100% - 40px);
   overflow-y: auto;
}
.div-bottom {
   height: 40px;
}
.ppp {
   border-color: #ced4da;
   background-color: #e9ecef;
}
.hover-click:hover {
   cursor: pointer;
}
</style>